<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3fqc2H/tc-custom/9781638291480.jpg?1725723409012" alt="This image is the cover for the book One Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>Vivian believed she had found love with Donovan, her partner with whom she renovated and shared a home, envisioning a future together. However, her dreams are shattered when Donovan abruptly ends their relationship. Refusing to drown in sorrow, Vivian sets out to find a new beginning and inadvertently stumbles upon a real estate office that would change her life forever.</p><p>There, she meets Andre, an irresistibly charming and strikingly handsome man who captures her attention like no one ever has. Andre is not just any real estate agent; he is one-half of the dynamic duo behind the popular home improvement show, House2Home. Just when Vivian thinks her luck couldn’t get any better, she encounters Sean, Andre’s equally captivating twin brother, adding an unexpected twist to her new venture.</p><p>To her astonishment, Vivian discovers she’s been selected to appear on their show. The twins are not only interested in transforming her living space but also, it seems, in winning her heart. As Vivian navigates this unexpected turn of events, she finds herself in a thrilling predicament: caught between two desires, each as alluring as the other.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Lea Bowen
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:black;background:white;'>Heather Lea Bowen loves a medium steak, good Kentucky whiskey, indulging in HGTV, and cheers loudly for the NFL team, the Seattle Seahawks. A Pacific Northwest native, she has begun writing contemporary adult romance novels about people you &lsquo;know&rsquo;. Her debut novel, <em>One Heart, </em>is now available.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23040554